// Vendor Libraries
import React from 'react';

// Redux Actions
import PanelAction from '../core/panel-action';

// Contexts
import {PanelContext} from '../../contexts/panel-context';

function MaximizePanelAction(props) {
    return (
        <PanelContext.Consumer>
            {({isPanelMaximized, togglePanelMaximized}) => (
                <PanelAction
                    {...{
                        weight: 1000,
                        ...props,
                    }}
                    icon={isPanelMaximized() ? 'window-restore' : 'window-maximize'}
                    title={isPanelMaximized() ? 'Restore Panel' : 'Maximize Panel'}
                    onClick={togglePanelMaximized}
                />
            )}
        </PanelContext.Consumer>
    );
}

export default MaximizePanelAction;
